module.exports = __webpack_public_path__ + "static/media/001-balloon-blue.be970a1d.svg";